<div class="modal-md terms-modal">
  <div class="modal-header state"></div>
  <div class="modal-body">
    <div class="scroll-container">
      <div [innerHTML]="content | safeContent"></div>
      @if (!withAcceptance) {
        <div class="mt-3 text-align-center">
          <button class="btn btn-outline-primary" (click)="close()">
            Close
          </button>
        </div>
      }
      @if (withAcceptance) {
        <div class="my-4 text-align-center control-buttons">
          <button type="button" class="btn-accept" (click)="acceptTerms()">
            ACCEPT TERMS & CONDITIONS
          </button>
          <button type="button" class="btn-decline" (click)="declineTerms()">
            DECLINE TERMS & CONDITIONS
          </button>
        </div>
      }
    </div>
  </div>
</div>
